/**
 * Workflow fields (`state.current_status`, `state.current_stage`, task status
 * shapes, etc.) may be a plain string (legacy) or structured
 * `{ label, value }`. Helpers normalize for display vs machine comparisons.
 */

export function podCurrentStatusToMachineString(status: unknown): string {
  if (status == null || status === "") return "";
  if (typeof status === "string") return status;
  if (typeof status === "object" && status !== null) {
    const o = status as Record<string, unknown>;
    if (typeof o.value === "string" && o.value.length > 0) return o.value;
    if (typeof o.label === "string" && o.label.length > 0) return o.label;
  }
  return "";
}

/** User-facing label — prefers API `label`, then falls back to `value` / string. */
export function podCurrentStatusToDisplayString(status: unknown): string {
  if (status == null || status === "") return "";
  if (typeof status === "string") return status;
  if (typeof status === "object" && status !== null) {
    const o = status as Record<string, unknown>;
    if (typeof o.label === "string" && o.label.length > 0) return o.label;
    if (typeof o.value === "string" && o.value.length > 0) return o.value;
  }
  return "";
}

/** Safe text for React children (workflow selects, CTA messages, metadata). */
export function asRenderableText(value: unknown): string {
  if (value == null || value === "") return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return (
    podCurrentStatusToDisplayString(value) ||
    podCurrentStatusToMachineString(value) ||
    ""
  );
}
